export const environment = {
  baseUrl: 'http://localhost:4200',
  production: true,
  version: '1.0.2',
  encryption: {
    saltB64: '',
    iterations: 200000,
  },
};
